var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('SaCounts'),_c('br'),_c('SaContent'),_c('br'),_c('SaTopSchools'),_c('br'),_c('v-divider'),_c('br')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }